module.exports = function() {
  return new Worker(__webpack_public_path__ + "e525abb471ab86f309e2.worker.js");
};


// WEBPACK FOOTER //
// ./src/systemwide/xlsx-parser.worker.js